import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../Redux';
import { getBaseFilename, isDarkModeEnabled } from '../../utils/commonUtils';
import localSpriteUrl from './local_sprite.svg';
import { LOCAL_ICON_LIST } from '../../config/icons';

type IconProps = {
  name: string;
  width?: number;
  className?: string;
  inline?: boolean; // switch between inline or external
  height?: number; // height of the icon
  darkModeIcnName?: string | undefined
};

const Icon=({ name, width = 24, className = '', height = 24, darkModeIcnName = undefined }: IconProps) => {

  const hasError = useSelector((state: RootState) => state?.globalStore?.svgSpriteHasError);
  const icnId = isDarkModeEnabled() && darkModeIcnName ? darkModeIcnName : name;
  const iconName = getBaseFilename(icnId);

  const isLocalIcon = LOCAL_ICON_LIST[iconName as keyof typeof LOCAL_ICON_LIST] !== undefined;

  const getSpriteUrl = () => {
    if (isLocalIcon) return `${localSpriteUrl}#${iconName}`;
    if (hasError) return `${localSpriteUrl}#brokenImgIcon`;
    return `#${iconName}`;
  };

  return (
    <svg width={width} height={height} className={`icon ${className}`}>
      <use href={`${getSpriteUrl()}`} />
    </svg>
  );
};

export default React.memo(Icon)
